import styled from "styled-components";

const StyledStream = styled.ins`
  height: 100%;
  width: 100%;
`;

export default StyledStream;
